import { render, staticRenderFns } from "./OtpPreview.vue?vue&type=template&id=2e314ffe"
import script from "./OtpPreview.vue?vue&type=script&lang=js"
export * from "./OtpPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports